'use client';

import { I18nProvider } from '@freedraw/i18n/react';
import type { AppLocale } from '@freedraw/i18n/shared';

import { LANDING_FONTS_URL } from '@/components/landing/landing-fonts';
import { LandingPage, type LandingPageProps } from '@/components/landing/landing-page';
import { MuiAppProvider } from '@/components/mui-app-provider';

// Render the landing content on the server so its headings, features and FAQs
// are present in the initial HTML for crawlers and visitors without JavaScript.
type LandingEntryProps = LandingPageProps & {
  initialLocale: AppLocale;
  initialTranslations: Record<string, unknown>;
};

export function LandingEntry({ initialLocale, initialTranslations, ...props }: LandingEntryProps) {
  return (
    <I18nProvider initialLocale={initialLocale} initialTranslations={initialTranslations}>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link rel="stylesheet" href={LANDING_FONTS_URL} precedence="default" />
      <MuiAppProvider initialPreference="light">
        <LandingPage {...props} />
      </MuiAppProvider>
    </I18nProvider>
  );
}
